<media-skeleton
    [holygrail2]="false"
    [ratio]="mediaConfig().ratio"
    class="product-media anim-skeleton is-anim"
    [ngClass]="{
        'is-anim': imageLoaded,
        'is-anim-2': videoLoaded
    }"
>
    <div
        skeletonMedia
        (click)="onClickMedia($event)"
        (keydown)="handleKeyDown($event)"
        tabindex="0"
        role="button"
        class="product-media__img"
        [ngClass]="{ 'cursor-pointer': mediaConfig().clickable }"
    >
        @defer (when videoUrl() && showVideo; prefetch on idle) {
            <media-video
                class="anim-2"
                [mediaVideoSettings]="{
                    classes: classes()
                }"
                (eventLoaded)="onVideoLoad()"
                [videoUrl]="videoUrl()"
                [hasInView]="hasInView()"
                (hlsError)="handleHlsError($event)"
                (videoElementRendered)="videoElementRendered.emit(true)"
                (hasAudio)="sendHasAudio($event)"
            ></media-video>
        }

        <!-- La imagen de servidor se cargará -->
        @if (mediaConfig().imagePriority) {
            <ng-container *ngTemplateOutlet="imageComponent"></ng-container>
        } @else {
            <!-- La imagen de cliente se cargará solo cuando esté en vista -->
            @defer (on viewport) {
                <ng-container *ngTemplateOutlet="imageComponent"></ng-container>
            } @placeholder {
                <div></div>
            }
        }
    </div>

    <ng-content select="[productCardBadge]" skeletonBadge class="product-card__badge"></ng-content>

    <ng-content select="[productCardFooter]" skeletonFooter class="product-card__footer"></ng-content>
</media-skeleton>

<ng-template #imageComponent>
    <div
        class="anim {{ mediaConfig().classImage }}"
        media-image
        [imageUrl]="imageUrl()"
        [imageModel]="mediaConfig()"
        (imageLoaded)="onImageLoad($event)"
        (imageError)="onImageError($event)"
    ></div>
</ng-template>
